import React, { useState } from 'react';
import { Flex, Text, Highlight, Icon, Button } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import { MdAdd, MdChevronLeft } from 'react-icons/md';

import { useGroup } from '../hooks/useGroup';
import BoardGameItem from '../components/BoardGameItem';
import SearchModal from '../components/SearchModal';
import Header from '../components/Header';

const BoardGameList = () => {
  const { groupId } = useParams();
  const { group, addBoardGame } = useGroup(groupId!);
  const [modal, setModal] = useState(false);
  if (!group) {
    return null;
  }

  return (
    <Flex
      pos="relative"
      h="100%"
      flexDirection="column"
      align="center"
      px="1rem"
      pb={8}
    >
      <Header title="보유한 보드게임" leftIcon={MdChevronLeft} leftTo={-1} />
      <Flex justifyContent="start" width="100%" gap="16px">
        <Button
          flex="1"
          color="white"
          bgColor="#D84E46"
          _active={{
            bgColor: '#AB170F',
          }}
          _hover={{
            bgColor: '#AB170F',
          }}
          fontWeight="semibold"
          p="9px"
          aria-label="add"
          leftIcon={<Icon as={MdAdd} />}
          onClick={() => setModal(true)}
        >
          보드게임 추가
        </Button>
      </Flex>
      <Text
        color="#383838"
        width="100%"
        fontWeight="bold"
        fontSize="18px"
        mt="20px"
        mb="14px"
      >
        <Highlight
          query={`${group.boardGames.length}`}
          styles={{ color: '#467FEC' }}
        >
          {`총 ${group.boardGames.length}개`}
        </Highlight>
      </Text>
      <Flex width="100%" flexDir="column" gap="13px">
        {group.boardGames.map((boardGameId) => (
          <BoardGameItem key={boardGameId} boardGameId={boardGameId} />
        ))}
      </Flex>
      {modal && (
        <SearchModal
          onClose={() => setModal(false)}
          isExist={(boardGameId) => group.boardGames.includes(boardGameId)}
          onRegister={(boardGameId) => addBoardGame(boardGameId)}
        />
      )}
    </Flex>
  );
};

export default BoardGameList;
